jQuery(function(){
  // homepage ga4 flash sale
  var flashflag={};
  function homeFlashlist(){
      var proitems=new Array();
    $("#homepage_flashsale-container .grid .grid__item.grid-product").each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
               product_realsku = "not set";
           }
           var propriceshow = $(this).find(".product-final-price").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var prolistname = "homepage_flashsale-products";
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&flashflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": prolistname,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
              });
              flashflag[proindexshow] = proindexshow;
            }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_item_list",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
   function viewflashsaleHandle(){
       homeFlashlist();
   }
   window.addEventListener('scroll', GAgdb(viewflashsaleHandle,1000));
  //end ga4 flash sale
    // homepage ga4 shop by look
  var shopbyflag={};
  function homeShopbylooklist(){
      var imgitems=new Array();
      $("#homepage_shopbylook .swiper-slide").each(function(){
           var imgindex=$(this).find(".ga4-display-img img").attr("alt");
           var csl=$(this).index();
           var iid = "homepage_shopbylook_image";
           var pid = "homepage_shopbylook_image";
           var cnm = $(this).find(".ga4-display-img img").attr("src");
           var pnm = $(this).find(".ga4-display-img img").attr("alt");
           if(GAiiv($(this))&&shopbyflag[csl] !== csl){
               imgitems.push({
                   "item_id": iid,
                   "item_name": pnm,
                   "promotion_id": pid,
                   "promotion_name": pnm,
                   "creative_name": cnm,
                   "creative_slot": csl
               }); 
               shopbyflag[csl] = csl
           }
      });
     if(imgitems.length>0){
           // console.log({
           //     "event":  "dle_view_promotion",
           //     "ecommerce":  {
           //         "items": imgitems
           //     }
           // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_promotion",
              "ecommerce": {
                "items": imgitems
              }
          })
       };
  }
   function viewshopbyimgHandle(){
       homeShopbylooklist();
   }
   window.addEventListener('scroll', GAgdb(viewshopbyimgHandle,1000));
  //end ga4 shop by look
   var mySwiper1 = new Swiper('.hu-collectionlist-lunb-pc', {
            slidesPerView : 5,
            spaceBetween : 15,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
             breakpoints: { 
      		 768: {
               
      			slidesPerView: 1.5,
      			spaceBetween: 15,
      			},
        	}
        }); 

   var mySwiper2 = new Swiper('.hu-featured-flash', {
            slidesPerView : 5,
            // spaceBetween : 15,
             navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              768: {
            slidesPerView:2.3,
            // spaceBetween: 15,
              },
            },
           scrollbar: {
              el: ".hu-featured-flash .swiper-scrollbar",
           },
        });


  
    // Send ga4 event start
  mySwiper2.on('slideNextTransitionEnd',function(){
      if(GAiiv($("#homepage_flashsale-container"))){
        homeFlashlist();
      }
  })
  // Send ga4 event end
      var mySwiper3 = new Swiper('.hu-collection-products', {
            slidesPerView : 4,
            spaceBetween : 15,
             navigation: {
              nextEl: '.hu-products-page .swiper-button-next',
              prevEl: '.hu-products-page .swiper-button-prev',
            },
            breakpoints: {
              768: {
            slidesPerView:2,
            spaceBetween: 15,
              },
            },
           pagination: {
              el: '.hu-products-page .swiper-pagination',
           },
        });

        var home_reviews = new Swiper('.hu-home-reviews', {
            slidesPerView : 3.5,
            spaceBetween : 15,
             navigation: {
              nextEl: '.hu-products-reviews .swiper-button-next',
              prevEl: '.hu-products-reviews .swiper-button-prev',
            },
            breakpoints: {
              768: {
            slidesPerView:1.5,
            spaceBetween: 15,
              },
            },
           scrollbar: {
              el: ".hu-home-reviews .swiper-scrollbar",
           },
        });
         // Send ga4 event start
  mySwiper3.on('slideNextTransitionEnd',function(){
      if(GAiiv($("#homepage_shopbylook"))){
        homeShopbylooklist();
      }
  })
  // Send ga4 event end
    // product fuzhi code
    function copyToClipboard(str) {
      let el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      let selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    }
    function copyCode(e) {
      let $this = e.target;
      copyToClipboard($this.getAttribute("data-code"));
      $this.innerText = "copied!";
      setTimeout(function () {
        $this.innerText = "copy";
      }, 1500);
    }
  
});

/* shouye daojishi js */
window.timeZoneParams = -8;
    /* getLocalTime:时区换算*/
    window.getLocalTime = function (i) {
        // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
        if (typeof i !== 'number') return;
        var d = new Date();
        //得到1970年一月一日到现在的秒数
        var len = d.getTime();
        //本地时间与GMT时间的时间偏移差
        var offset = d.getTimezoneOffset() * 60000;
        //得到现在的格林尼治时间
        var utcTime = len + offset;
        return new Date(utcTime + 3600000 * i);
    }
    /*end getLocalTime:时区换算*/
    window.getNextDate = function(date, day) {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "/" + m + "/" + d;
    }


    $(function () {
        if ($(".memberFlash-timeBox").length) {
            var date = getLocalTime(timeZoneParams);
            var date_day = date.getDate();
            var date_month = date.getMonth() + 1;
            var date_year = date.getFullYear();
            var endTime = getNextDate(date_year + "/" + date_month + "/" + date_day, 1);
            var endAllTime = new Date(endTime).getTime() - date;
            function timerMember(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0; 
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor((intDiff / 1000 / 60) % 60);
                    second = Math.floor((intDiff / 1000) % 60);
                }
                var hourInt =  parseInt(hour / 10);
                hourInt == 2 ? (int1 = 0) : (int1 = hourInt + 1);
                var hourDot = hour % 10;
                hourDot == 9 ? (int2 = 0) : (int2 = hourDot + 1);
              // console.log(hourInt)
                if (!$(".hl .item").eq(hourInt).hasClass("active")) {
                    $(".hl .item.before").removeClass("before");
                    $(".hl .item").eq(int1).addClass("before");
                    $(".hl .item.active").removeClass("active");
                    $(".hl .item").eq(hourInt).addClass("active");

                }

                if (!$(".hr .item").eq(hourDot).hasClass("active")) {
                    $(".hr .item.before").removeClass("before");
                    $(".hr .item").eq(int2).addClass("before");
                    $(".hr .item.active").removeClass("active");
                    $(".hr .item").eq(hourDot).addClass("active");
                }

                var minuteInt =  parseInt(minute / 10);
                minuteInt == 5 ? (int3 = 0) : (int3 = minuteInt + 1);
                var minuteDot = minute % 10;
                minuteDot == 9 ? (int4 = 0) : (int4 = minuteDot + 1);
                if (!$(".ml .item").eq(minuteInt).hasClass("active")) {
                    $(".ml .item.active").removeClass("active");
                    $(".ml .item").eq(minuteInt).addClass("active");
                    $(".ml .item.before").removeClass("before");
                    $(".ml .item").eq(int3).addClass("before");
                }

                if (!$(".mr .item").eq(minuteDot).hasClass("active")) {
                    $(".mr .item.active").removeClass("active");
                    $(".mr .item").eq(minuteDot).addClass("active");
                    $(".mr .item.before").removeClass("before");
                    $(".mr .item").eq(int4).addClass("before");
                }



                var secondInt =  parseInt(second / 10);
                secondInt == 5 ? (int5 = 0) : (int5 = secondInt + 1);
                var secondDot = second % 10;
                secondDot == 9 ? (int6 = 0) : (int6 = secondDot + 1);
                if (!$(".sl .item").eq(secondInt).hasClass("active")) {
                    $(".sl .item.active").removeClass("active");
                    $(".sl .item").eq(secondInt).addClass("active");
                    $(".sl .item.before").removeClass("before");
                    $(".sl .item").eq(int5).addClass("before");
                }

                if (!$(".sr .item").eq(secondDot).hasClass("active")) {
                    $(".sr .item.active").removeClass("active");
                    $(".sr .item").eq(secondDot).addClass("active");
                    $(".sr .item.before").removeClass("before");
                    $(".sr .item").eq(int6).addClass("before");
                }
            }


            function timerMember2(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0; 
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor((intDiff / 1000 / 60) % 60);
                    second = Math.floor((intDiff / 1000) % 60);
                }
                var hourInt =  parseInt(hour / 10);
              
                hourInt == 2 ? (int1 = 0) : (int1 = hourInt + 1);
                var hourDot = hour % 10;
                hourDot == 9 ? (int2 = 0) : (int2 = hourDot + 1);
              // console.log(hourInt)
                if (!$(".bf-hl .item").eq(hourInt).hasClass("active")) {
                    $(".bf-hl .item.before").removeClass("before");
                    $(".bf-hl .item").eq(int1).addClass("before");
                    $(".bf-hl .item.active").removeClass("active");
                    $(".bf-hl .item").eq(hourInt).addClass("active");

                }

                if (!$(".bf-hr .item").eq(hourDot).hasClass("active")) {
                    $(".bf-hr .item.before").removeClass("before");
                    $(".bf-hr .item").eq(int2).addClass("before");
                    $(".bf-hr .item.active").removeClass("active");
                    $(".bf-hr .item").eq(hourDot).addClass("active");
                }

                var minuteInt =  parseInt(minute / 10);
                minuteInt == 5 ? (int3 = 0) : (int3 = minuteInt + 1);
                var minuteDot = minute % 10;
                minuteDot == 9 ? (int4 = 0) : (int4 = minuteDot + 1);
                if (!$(".bf-ml .item").eq(minuteInt).hasClass("active")) {
                    $(".bf-ml .item.active").removeClass("active");
                    $(".bf-ml .item").eq(minuteInt).addClass("active");
                    $(".bf-ml .item.before").removeClass("before");
                    $(".bf-ml .item").eq(int3).addClass("before");
                }

                if (!$(".bf-mr .item").eq(minuteDot).hasClass("active")) {
                    $(".bf-mr .item.active").removeClass("active");
                    $(".bf-mr .item").eq(minuteDot).addClass("active");
                    $(".bf-mr .item.before").removeClass("before");
                    $(".bf-mr .item").eq(int4).addClass("before");
                }



                var secondInt =  parseInt(second / 10);
                secondInt == 5 ? (int5 = 0) : (int5 = secondInt + 1);
                var secondDot = second % 10;
                secondDot == 9 ? (int6 = 0) : (int6 = secondDot + 1);
                if (!$(".bf-sl .item").eq(secondInt).hasClass("active")) {
                    $(".bf-sl .item.active").removeClass("active");
                    $(".bf-sl .item").eq(secondInt).addClass("active");
                    $(".bf-sl .item.before").removeClass("before");
                    $(".bf-sl .item").eq(int5).addClass("before");
                }

                if (!$(".bf-sr .item").eq(secondDot).hasClass("active")) {
                    $(".bf-sr .item.active").removeClass("active");
                    $(".bf-sr .item").eq(secondDot).addClass("active");
                    $(".bf-sr .item.before").removeClass("before");
                    $(".bf-sr .item").eq(int6).addClass("before");
                }
            }


				
			function timerMember3(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0; 
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor((intDiff / 1000 / 60) % 60);
                    second = Math.floor((intDiff / 1000) % 60);
                }
                var hourInt =  parseInt(hour / 10);
              
                hourInt == 2 ? (int1 = 0) : (int1 = hourInt + 1);
                var hourDot = hour % 10;
                hourDot == 9 ? (int2 = 0) : (int2 = hourDot + 1);
              // console.log(hourInt)
                if (!$(".me-hl .item").eq(hourInt).hasClass("active")) {
                    $(".me-hl .item.before").removeClass("before");
                    $(".me-hl .item").eq(int1).addClass("before");
                    $(".me-hl .item.active").removeClass("active");
                    $(".me-hl .item").eq(hourInt).addClass("active");

                }

                if (!$(".me-hr .item").eq(hourDot).hasClass("active")) {
                    $(".me-hr .item.before").removeClass("before");
                    $(".me-hr .item").eq(int2).addClass("before");
                    $(".me-hr .item.active").removeClass("active");
                    $(".me-hr .item").eq(hourDot).addClass("active");
                }

                var minuteInt =  parseInt(minute / 10);
                minuteInt == 5 ? (int3 = 0) : (int3 = minuteInt + 1);
                var minuteDot = minute % 10;
                minuteDot == 9 ? (int4 = 0) : (int4 = minuteDot + 1);
                if (!$(".me-ml .item").eq(minuteInt).hasClass("active")) {
                    $(".me-ml .item.active").removeClass("active");
                    $(".me-ml .item").eq(minuteInt).addClass("active");
                    $(".me-ml .item.before").removeClass("before");
                    $(".me-ml .item").eq(int3).addClass("before");
                }

                if (!$(".me-mr .item").eq(minuteDot).hasClass("active")) {
                    $(".me-mr .item.active").removeClass("active");
                    $(".me-mr .item").eq(minuteDot).addClass("active");
                    $(".me-mr .item.before").removeClass("before");
                    $(".me-mr .item").eq(int4).addClass("before");
                }



                var secondInt =  parseInt(second / 10);
                secondInt == 5 ? (int5 = 0) : (int5 = secondInt + 1);
                var secondDot = second % 10;
                secondDot == 9 ? (int6 = 0) : (int6 = secondDot + 1);
                if (!$(".me-sl .item").eq(secondInt).hasClass("active")) {
                    $(".me-sl .item.active").removeClass("active");
                    $(".me-sl .item").eq(secondInt).addClass("active");
                    $(".me-sl .item.before").removeClass("before");
                    $(".me-sl .item").eq(int5).addClass("before");
                }

                if (!$(".me-sr .item").eq(secondDot).hasClass("active")) {
                    $(".me-sr .item.active").removeClass("active");
                    $(".me-sr .item").eq(secondDot).addClass("active");
                    $(".me-sr .item.before").removeClass("before");
                    $(".me-sr .item").eq(int6).addClass("before");
                }
            }


              var groupTime = setInterval(function () {
                if (endAllTime > 0) {
                    timerMember(endAllTime);
                    timerMember2(endAllTime);
                    timerMember3(endAllTime);
                    endAllTime -= 1000;
                } else {
                    date = getLocalTime(timeZoneParams);
                    date_day = date.getDate();
                    date_month = date.getMonth() + 1;
                    date_year = date.getFullYear();
                    endTime = getNextDate(date_year + "/" + date_month + "/" + date_day,1);
                    endAllTime = new Date(endTime).getTime() - date;
                    if (typeof every_flash_enable != "undefined" && every_flash_enable == '1') {
                        homeFlash();
                    }
                }

            
            }, 1000);
        }
    })



    // 新版倒计时（含毫秒 + 修复天数崩溃）
    function getLocalTime(i) {
    if (typeof i !== 'number') return;
    var d = new Date();
    var len = d.getTime();
    var offset = d.getTimezoneOffset() * 60000;
    var utcTime = len + offset;
    return new Date(utcTime + 3600000 * i);
    }

    window.getNextDate = function(date, day) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "/" + m + "/" + d;
    }

    jQuery(function() {
    if (jQuery('.endsIn').length || jQuery('.memberFlash-timeBox').length || jQuery('.flash-end').length) {
        var additionalDays = 4; 
        var date = getLocalTime(timeZoneParams);
        var date_day = date.getDate() + additionalDays;
        var date_month = date.getMonth() + 1;
        var date_year = date.getFullYear();
        var maxDaysInMonth = new Date(date_year, date_month, 0).getDate();
        
        // 处理跨月/跨年（原逻辑不变）
        if (date_day > maxDaysInMonth) {
        var extraDays = date_day - maxDaysInMonth;
        date_month++;
        if (date_month > 12) {
            date_year++;
            date_month = 1;
        }
        date_day = extraDays;
        }
        
        // 计算初始结束时间（原逻辑不变）
        var endTimeStr = getNextDate(date_year + '/' + date_month + '/' + date_day, 1);
        var endTime = new Date(endTimeStr).getTime(); // 存储结束时间戳（固定）
        var endAllTime = endTime - date.getTime(); // 初始剩余时间

        // 新增：存储上一次的时间值，避免重复更新DOM（解决闪烁+崩溃）
        var lastValues = {
        day: '',
        hour: '',
        minute: '',
        second: '',
        millisecond: ''
        };

        function timerMember(intDiff) {
        var day = 0,
            hour = 0,
            minute = 0,
            second = 0,
            millisecond = 0;

        intDiff = intDiff - 0;
        if (intDiff > 0) {
            // 计算逻辑不变，但优化天数计算（避免负数或异常值）
            day = Math.max(0, Math.floor(intDiff / 1000 / 60 / 60 / 24)); // 确保天数≥0
            var remainingAfterDay = intDiff % (1000 * 60 * 60 * 24); // 天之后的剩余时间
            
            hour = Math.max(0, Math.floor(remainingAfterDay / 1000 / 60 / 60));
            var remainingAfterHour = remainingAfterDay % (1000 * 60 * 60);
            
            minute = Math.max(0, Math.floor(remainingAfterHour / 1000 / 60));
            var remainingAfterMinute = remainingAfterHour % (1000 * 60);
            
            second = Math.max(0, Math.floor(remainingAfterMinute / 1000));
            millisecond = Math.floor((remainingAfterMinute % 1000) / 10);
        }

        // 补零逻辑（原逻辑不变）
        day = day < 10 ? '0' + day : day;
        hour = hour < 10 ? '0' + hour : hour;
        minute = minute < 10 ? '0' + minute : minute;
        second = second < 10 ? '0' + second : second;
        millisecond = millisecond < 10 ? '0' + millisecond : millisecond;

        // 关键修复：只在数值变化时更新DOM（避免重复操作导致的崩溃）
        if (day !== lastValues.day) {
            jQuery('.flashSale-clock_timeD').text(day);
            lastValues.day = day;
        }
        if (hour !== lastValues.hour) {
            jQuery('.flashSale-clock_timeH').text(hour);
            lastValues.hour = hour;
        }
        if (minute !== lastValues.minute) {
            jQuery('.flashSale-clock_timeM').text(minute);
            lastValues.minute = minute;
        }
        if (second !== lastValues.second) {
            jQuery('.flashSale-clock_timeS').text(second);
            lastValues.second = second;
        }
        if (millisecond !== lastValues.millisecond) {
            jQuery('.flashSale-clock_timeMs').text(millisecond);
            lastValues.millisecond = millisecond;
        }

        // 原有分拆数字的逻辑（不变）
        var str1 = hour + '';
        var s1 = str1.substr(0, 1);
        jQuery('.memberFlash-time_timeH_one').text(s1);
        jQuery('.memberFlash-time_timeH_two').text(str1.charAt(str1.length-1));
        
        var str2 = minute + '';
        var s2 = str2.substr(0, 1);
        jQuery('.memberFlash-time_timeM_one').text(s2);
        jQuery('.memberFlash-time_timeM_two').text(str2.charAt(str2.length-1));
        
        var str3 = second + '';
        var s3 = str3.substr(0, 1);
        jQuery('.memberFlash-time_timeS_one').text(s3);
        jQuery('.memberFlash-time_timeS_two').text(str3.charAt(str3.length-1));
        }

        // 定时器间隔保持10ms（原逻辑不变）
        var groupTime = setInterval(function() {
        if (endAllTime > 0) {
            timerMember(endAllTime);
            endAllTime -= 10; // 每次减10ms（对应定时器间隔）
        } else {
            // 倒计时结束后重置（修复重置逻辑，避免天数异常）
            var newDate = getLocalTime(timeZoneParams);
            var newDateDay = newDate.getDate() + additionalDays; // 恢复初始的+4天逻辑
            var newDateMonth = newDate.getMonth() + 1;
            var newDateYear = newDate.getFullYear();
            var newMaxDays = new Date(newDateYear, newDateMonth, 0).getDate();
            
            // 重置时也要处理跨月/跨年
            if (newDateDay > newMaxDays) {
            var newExtraDays = newDateDay - newMaxDays;
            newDateMonth++;
            if (newDateMonth > 12) {
                newDateYear++;
                newDateMonth = 1;
            }
            newDateDay = newExtraDays;
            }
            
            endTimeStr = getNextDate(newDateYear + '/' + newDateMonth + '/' + newDateDay, 1);
            endTime = new Date(endTimeStr).getTime();
            endAllTime = endTime - newDate.getTime(); // 用新的当前时间计算剩余时间
        }
        }, 10);
    }
    });

// 指定时间倒计时
jQuery(function() {
        if (jQuery('.endsIn-new').length || jQuery('.memberFlash-timeBox').length) {
          
            var date = getLocalTime(timeZoneParams);
            var date_day = date.getDate();
            var date_month = date.getMonth() + 1;
            var date_year = date.getFullYear();
            var endTime = getNextDate(date_year + '/' + date_month + '/' + date_day, 1);

            // var  hustart_time = '2024/07/08 00:00:00'
            var  huend_time = '2025/12/15 00:00:00'
            var endAllTime = new Date(huend_time).getTime() - date;
            function timerMember(intDiff) {
                var day = 0,
                    hour = 0,
                    minute = 0,
                    second = 0;
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    day = Math.floor(intDiff / 1000 / 60 / 60 / 24);
                    hour = Math.floor(intDiff / 1000 / 60 / 60 % 24);
                    minute = Math.floor(intDiff / 1000 / 60 % 60);
                    second = Math.floor(intDiff / 1000 % 60);
                }
                if (day < 10) {
                    day = '0' + day;
                }
                if (hour < 10) {
                    hour = '0' + hour;
                }
                if (minute < 10) {
                    minute = '0' + minute;
                }
                if (second < 10) {
                    second = '0' + second;
                }
                jQuery('.flashSale-clock_timeD').text(day);
                jQuery('.flashSale-clock_timeH').text(hour);
                jQuery('.flashSale-clock_timeM').text(minute);
                jQuery('.flashSale-clock_timeS').text(second);
                // 时
                var str1 = hour + '';
                var s1 = str1.substr(0, 1);
                jQuery('.memberFlash-time_timeH_one').text(s1);
                jQuery('.memberFlash-time_timeH_two').text(str1.charAt(str1.length-1));
                // 分
                var str2=minute + '';
                var s2=str2.substr(0, 1);
                jQuery('.memberFlash-time_timeM_one').text(s2);
                jQuery('.memberFlash-time_timeM_two').text(str2.charAt(str2.length-1));
                // 秒
                var str3=second + '';
                var s3=str3.substr(0, 1);
                jQuery('.memberFlash-time_timeS_one').text(s3);
                jQuery('.memberFlash-time_timeS_two').text(str3.charAt(str3.length-1));
            }
            var groupTime = setInterval(function() {
                if (endAllTime > 0) {
                    timerMember(endAllTime);
                    endAllTime -= 1000;
                } else {
                    date = getLocalTime(timeZoneParams);
                    date_day = date.getDate();
                    date_month = date.getMonth();
                    date_year = date.getFullYear();
                    endTime = getNextDate(date_year + '/' + date_month + '/' + date_day);
                    endAllTime = new Date(endTime).getTime() - date;
                }
            }, 1000);
        }

    })
// 指定时间倒计时


// blog scoll top -by jack
 $(function(){
    var offset = 100;
    var speed = 250;
    var duration = 500;
        $(window).scroll(function(){
            if ($(this).scrollTop() < offset) {
                      $('#footer-back-to-top') .fadeOut(duration);
            } else {
                      $('#footer-back-to-top') .fadeIn(duration);
            }
        });
     $('#footer-back-to-top').on('click', function(){
            $('html, body').animate({scrollTop:0}, speed);
            return false;
            });
});
// fenqi
function openPopup(e) {
      	if( e == "paypal" ){
          jQuery('.pc_home_tanchuang-paypal').removeClass("hu_none");
                jQuery('.window-cover').show();
        }
        if( e == "afterpay" ){
            jQuery('.pc_home_tanchuang-afterpay').removeClass("hu_none");
                jQuery('.window-cover').show();
          }
        if( e == "klarna" ){
          jQuery('.pc_home_tanchuang-klarna').removeClass("hu_none");
                jQuery('.window-cover').show();
        }
        if( e == "length" ){
          jQuery('.pc_home_tanchuang-length').removeClass("hu_none");
                jQuery('.window-cover').show();
        }
    }


function closePopup(e) {
      	if( e == "paypal" ){
          jQuery('.pc_home_tanchuang-paypal').addClass("hu_none");
          jQuery('.window-cover').hide();
        }
        if( e == "afterpay" ){
            jQuery('.pc_home_tanchuang-afterpay').addClass("hu_none");
          jQuery('.window-cover').hide();
          }
        if( e == "klarna" ){
          jQuery('.pc_home_tanchuang-klarna').addClass("hu_none");
          jQuery('.window-cover').hide();
        }
        if( e == "length" ){
          jQuery('.pc_home_tanchuang-length').addClass("hu_none");
          jQuery('.window-cover').hide();
        }

        if( e == "discount" ){
          jQuery('.pc_home_tanchuang-discount').addClass("hu_none");
          jQuery('.window-cover').hide();
        }

        // 新增：bathrobe弹窗关闭逻辑
        if( e == "bathrobe" ){
            jQuery('.pc_home_tanchuang-bathrobe').addClass("hu_none");
            jQuery('.window-cover').hide();
        }
    }

$(document).ready(function() {
    var currentPath = window.location.pathname;
    var isCartOrCheckout = currentPath.includes('/cart') || 
                          currentPath.includes('/checkout') || 
                          currentPath.includes('/checkouts');
    
    const popupKey = 'bathrobePopupLastShow';
    const oneHour = 60 * 60 * 1000;
    const lastShowTime = localStorage.getItem(popupKey);
    const now = new Date().getTime();
    
    if (!isCartOrCheckout && (!lastShowTime || now - lastShowTime > oneHour)) {
        $('.pc_home_tanchuang-bathrobe').removeClass("hu_none");
        localStorage.setItem(popupKey, now);
    }
});


$(document).ready(function(){
  $(window).scroll(function(){
    if ($(this).scrollTop() > 270) {
      $('.header-sticky-wrapper').addClass('hu_gototop');
    } else {
      $('.header-sticky-wrapper').removeClass('hu_gototop');
    }
  });

  $('.hu_search').focus(function() {
      $('.site-header__search-container').addClass('is-active');
     $('.site-header__search-container').show();
  });
  $('.js-search-header').click(function() {
      $('.site-header__search-container').addClass('is-active');
     $('.site-header__search-container').show();
  });
  $('.js-search-header-close').click(function() {
      $('.site-header__search-container').hide();
  });
});

// 绑定购物车加减事件
$(function() {
            $(".js-qty__wrapper-hx .js-qty__adjust--plus").click(function() {
                var  qty = $(this).siblings(".js-qty__num").val();
                qty++;
                $(this).siblings(".js-qty__num").val(qty);
            });
            $(".js-qty__wrapper-hx .js-qty__adjust--minus").click(function() {
                var  qty = $(this).siblings(".js-qty__num").val();
                if (qty == 0) {
                    return false;
                }
                qty--;
               $(this).siblings(".js-qty__num").val(qty);
            });
        });

// 购物车订单备注
jQuery(function(){
  jQuery('.cart-right .note .icon').on('click', function(){
      jQuery('textarea#CartNote').toggle();
  });
})

// 判断链接弹窗
// 封装URL判断函数
function isCurrentUrl(targetUrl) {
  return window.location.href === targetUrl;
}

// DOM加载完成后执行
document.addEventListener('DOMContentLoaded', function() {
  if (isCurrentUrl('https://www.cynosurehair.com/cart?utm_source=Yotpo&utm_medium=SMS&utm_campaign=cart-ABtest5off#promo=4U5')) {
    // 显示弹窗
    jQuery('.pc_home_tanchuang-discount').removeClass("hu_none");
    jQuery('.window-cover').show();
  }else{
    // console.log('未匹配到目标链接');
  }
});

// DOM加载完成后执行
document.addEventListener('DOMContentLoaded', function() {
  if (isCurrentUrl('https://www.cynosurehair.com/cart?utm_source=Mamba&utm_medium=SMS&utm_campaign=cart-ABtest5off-01#promo=4U5')) {
    // 显示弹窗
    jQuery('.pc_home_tanchuang-discount').removeClass("hu_none");
    jQuery('.window-cover').show();
  }else{
    // console.log('未匹配到目标链接');
  }
});

// 一键跳到顶部
$(window).scroll(function() {
    var backToTopBtn = $('#backToTopBtn');
    if ($(window).scrollTop() > 200) { 
        backToTopBtn.fadeIn();
    } else { 
        backToTopBtn.fadeOut();
    }
});


$('#backToTopBtn').click(function() {
    $('html, body').animate({
        scrollTop: 0
    }, 500, function() {
        $('#backToTopBtn').fadeOut(); // 跳到顶部后隐藏按钮
    });
});

// cvip-coupons复制功能
function copyCodeClipboard(e) {
    var i = document.createElement("textarea");
    i.value = e, i.setAttribute("readonly", ""), i.style.position = "absolute", i.style.left = "-9999px", document.body.appendChild(i);
    var t = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : !1;
    i.select(), document.execCommand("copy"), document.body.removeChild(i), t && (document.getSelection().removeAllRanges(), document.getSelection().addRange(t))
}

function copyCoupons(e) {
    var i = e.target;
    copyCodeClipboard(i.getAttribute("data-code"));
    alert("Copy successfully！"); // 添加弹窗提示
}

// 首页新轮播 sections\featured-collection-swiper.liquid
var mySwiper4 = new Swiper('.hu-featured-swiper', {
    slidesPerView: 5,
    spaceBetween : 15,
    navigation: { 
        nextEl: '.hu-flash-swiper .swiper-button-next', 
        prevEl: '.hu-flash-swiper .swiper-button-prev', 
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
        spaceBetween: 15
      }
    },

    scrollbar: {
      el: ".hu-featured-swiper .swiper-scrollbar",
      draggable: true,
      hide: false
    }
});


// 首页视频
(function(){

  var video_swiper = new Swiper('.her-pro_video_videos-carousel-wrapper', {
      slidesPerView: 5.2,
      spaceBetween: 30,

      navigation: {
        nextEl: '#her-pro_video_videoNextBtn',
        prevEl: '#her-pro_video_videoPrevBtn'
      },

      breakpoints: {

        // 手机
        768: {
          slidesPerView: 1.5,
          spaceBetween: 12
        }

      }

  });

  const containers = document.querySelectorAll(
    '.her-pro_video_video-player-container'
  );

  containers.forEach(function(container){

    const cover = container.querySelector(
      '.her-pro_video_video-cover'
    );

    const video = container.querySelector(
      '.her-pro_video_video-player'
    );

    const playIcon = container.querySelector(
      '.her-pro_video_play-icon'
    );

    container.addEventListener('click', function(){

      if(video.paused){

        document
          .querySelectorAll('.her-pro_video_video-player')
          .forEach(function(v){

            if(v !== video){

              v.pause();

              v.style.display = 'none';

              const parent = v.closest(
                '.her-pro_video_video-player-container'
              );

              if(parent){

                const c = parent.querySelector(
                  '.her-pro_video_video-cover'
                );

                const p = parent.querySelector(
                  '.her-pro_video_play-icon'
                );

                if(c) c.style.display = 'block';
                if(p) p.style.display = 'flex';
              }
            }

          });

        playIcon.style.display = 'none';
        const onPlaying = function() {

          cover.style.display = 'none';
          video.style.display = 'block';

          video.removeEventListener('playing', onPlaying);

        };
        video.addEventListener('playing', onPlaying);

        video.play().catch(function(){

          video.removeEventListener('playing', onPlaying);

          playIcon.style.display = 'flex';

        });

      } else {

        video.pause();

        cover.style.display = 'block';
        video.style.display = 'none';
        playIcon.style.display = 'flex';
      }

    });

    video.addEventListener('ended', function(){

      video.pause();

      video.style.display = 'none';

      cover.style.display = 'block';

      playIcon.style.display = 'flex';

      video.currentTime = 0;

    });

  });

})();
// 首页视频
// 首页sections\hu-trustpilot-reviews.liquid
$('.hu-trustpilot-swiper').each(function () {
    new Swiper(this, {
        slidesPerView: 3.3,
        spaceBetween: 20,
        navigation: {
            nextEl: $(this).find('.swiper-button-next')[0],
            prevEl: $(this).find('.swiper-button-prev')[0]
        },
        breakpoints: {
            768: {
                slidesPerView: 1.3,
                spaceBetween: 8
            }
        }
    });
});


